<main class="container-fluid  ">
<!--    <div class="d-flex justify-content-end" style="display:none;" >-->
<!--        <button mat-raised-button color="primary" class="m-2" (click)="generatePDF()">Download</button>-->
<!--    </div>-->
    <div class="m-2 " style="display:none;">

        <div class="card mx-2 ">
            <div class="row mx-3">
                <mat-form-field appearance="outline" class="col-md-6 mt-2">
                    <mat-label>Select Centre</mat-label>
                    <mat-select [(ngModel)]="selectedCentre" #selectElement (selectionChange)="OnCentreChange($event)">
                        <mat-option *ngFor=" let c of (centres$|async) "
                                    [value]="c.centreCode">{{c.centreName}} </mat-option>
                        <!--      <mat-option  value="All">All Centres</mat-option>-->
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="col-md-4 mt-2">
                    <mat-label>Enter a date range</mat-label>
                    <mat-date-range-input [rangePicker]="picker">
                        <input matStartDate [(ngModel)]="mStartDate" placeholder="Start date">
                        <input matEndDate [(ngModel)]="mEndDate" placeholder="End date">
                    </mat-date-range-input>
                    <mat-hint>dd/MM/yyyy – dd/MM/yyyy</mat-hint>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>

                    <!--                @if (range.controls.start.hasError('matStartDateInvalid')) {-->
                    <!--                <mat-error>Invalid start date</mat-error>-->
                    <!--                }-->
                    <!--                @if (range.controls.end.hasError('matEndDateInvalid')) {-->
                    <!--                <mat-error>Invalid end date</mat-error>-->
                    <!--                }-->
                </mat-form-field>

                <button class="col-md-2 mt-2" mat-mini-fab color="accent" (click)="Search()">
                    <mat-icon>search</mat-icon>
                </button>
                <mat-form-field appearance="outline" class=" col-md-4">
                    <mat-label>Total Teachers Sessions</mat-label>
                    <input matInput inputmode="number" [(ngModel)]="mTeacherSessions+mTeacherSessionsGroup-mDaysObserved">
                </mat-form-field>
                <mat-form-field appearance="outline" class=" col-md-4">
                    <mat-label>Total Volunteer Sessions</mat-label>
                    <input matInput inputmode="number" [(ngModel)]="mVolunteerSessions+mVolunteerSessionsGroup">
                </mat-form-field>

                <mat-form-field appearance="outline" class="col-md-4">
                    <mat-label>Total Special Days</mat-label>
                    <input matInput inputmode="number" [(ngModel)]="mDaysObserved">
                </mat-form-field>
                <!--              <mat-form-field appearance="outline" class="col-md-4">-->
                <!--                  <mat-label>Total Admissions</mat-label>-->
                <!--                  <input matInput inputmode="number" [(ngModel)]="mTotalAdmissions">-->
                <!--              </mat-form-field>-->
                <!--              <mat-form-field appearance="outline" class="col-md-4">-->
                <!--                  <mat-label>Total Discharge</mat-label>-->
                <!--                  <input matInput inputmode="number" [(ngModel)]="mTotalDischarge">-->
                <!--              </mat-form-field>-->

            </div>


            <div class="mx-4">
                <!--                <ckeditor [editor]="Editor" [data]="editorData" (change)="onEditorChange($event)"></ckeditor>-->
                <br>
<!--                <p-editor [(ngModel)]="highlights" [style]="{ height: '320px' }"></p-editor>-->
              <ckeditor
                [editor]="Editor"
                [(ngModel)]="highlights"
                style="height: 300px"
              ></ckeditor>
                <div class="row mt-2 mb-4">
                    <div class="col-md-4">
                        <label for="educationFiles">Education Session:</label>
                        <input id="educationFiles" type="file" accept="image/*" multiple (change)="onFilesSelected($event)"/>

                    </div>
                    <div class="col-md-4">
                        <label for="celebrationFiles">Celebration:</label>
                        <input id="celebrationFiles" type="file" accept="image/*" multiple (change)="onFilesSelected1($event)"/>
                    </div>

                    <div class="col-md-4">
                        <label for="volunteeringFiles">Volunteering Session:</label>
                        <input id="volunteeringFiles" type="file" accept="image/*" multiple (change)="onFilesSelected2($event)"/>
                    </div>


                </div>


                <!--              <div class="dropdown">-->
                <!--                <button class="btn btn-secondary dropdown-toggle" type="button" id="categoryDropdown" data-bs-toggle="dropdown" aria-expanded="false">-->
                <!--                  Select Category-->
                <!--                </button>-->
                <!--                <ul class="dropdown-menu" aria-labelledby="categoryDropdown">-->
                <!--                  <li><a class="dropdown-item" href="#" (click)="selectCategory('Education Session')">Education Session</a></li>-->
                <!--                  <li><a class="dropdown-item" href="#" (click)="selectCategory('Celebration')">Celebration</a></li>-->
                <!--                  <li><a class="dropdown-item" href="#" (click)="selectCategory('Volunteering Session')">Volunteering Session</a></li>-->
                <!--                </ul>-->
                <!--              </div>-->
                <!--        <div class=" d-flex flex-column col-md-2 m-1">-->
                <!--          <label for="galleryImages">Gallery Images: </label>-->
                <!--          <button id="galleryImages" mat-raised-button color="primary" (click)="openGallery()">Upload</button>-->
                <!--        </div>-->
                <div class="d-flex justify-content-center">

                    <mat-form-field appearance="outline" class="mx-2 mt-2">
                        <mat-label>Select Before Submit</mat-label>
                        <mat-select (selectionChange)="getValues($event)"  >
                            <mat-option value="draft">Draft</mat-option>
                            <mat-option value="final">Final</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <button mat-raised-button color="primary" class="m-2" (click)="save()">Submit</button>
                              <button mat-raised-button color="primary" class="m-2" (click)="generatePDF()">Download</button>
                </div>
            </div>

        </div>

    </div>
<div class="d-flex justify-content-end">
  <button mat-raised-button color="primary" class="m-2" (click)="printDoc()">Download</button>
</div>
  <div class="bg-white" #content id="preview">
    <section>
      <div style="display: flex; justify-content: flex-end;">
        <img style="height: 100px;" src="../../../../../assets/logo.png" alt="logo">
      </div>
    </section>

    <section class=" text-dark">
      <div class="text-center">
        <h2 class="mb-0"><strong>NON-FORMAL EDUCATION INTERVENTION IMPACT REPORT</strong></h2>

        <h4 class="mb-3 fw-bold ">
          <span *ngIf="mStartDate!=null && mEndDate!=null"> {{mCentre?.centreName}}
            , {{mStartDate|date:'dd MMMM yyyy'}} – {{mEndDate|date:'dd MMMM yyyy'}}</span>
        </h4>
      </div>
      <div class="mx-8">
        <p style="text-align: justify; text-justify: inter-word">
          Non-formal education Intervention at Accesslife Assistance Foundation was initiated to bridge the
          gap and help
          children be in touch with their education. So that after successfully completing their treatment,
          children can have a
          co-relation with their ongoing studies despite the lapse during treatment. The baseline assessment,
          intermediate
          assessment, discharge assessment, and IEP goals are being planned and implemented by our teachers.
          From <span *ngIf="mStartDate!=null && mEndDate!=null"> {{mStartDate|date:'dd MMMM yyyy'}}
          till {{mEndDate|date:'dd MMMM yyyy'}}</span>
          , the following are the details for the {{mCentre?.centreName}}
          Centre.
        </p>

        <p class="fw-bold">
          Our intervention caters to children from the age group of 04 years to 14 years.</p>

        <p style="text-align: justify; text-justify: inter-word">
          Toddlers are handled by our
          volunteers under the guidance of our teachers. Volunteers take care of various activities which are
          conducted for
          toddlers on a day-to-day basis. They overall take care of Gross Motor and Fine Motor skills.
        </p>

      </div>

      <table style="margin-left: 80px; width: 80%; text-align: center; border-collapse: collapse; border: 1px solid black;">
        <tr>
          <th style="padding: 10px; border: 1px solid black;"></th>
          <td style="padding: 10px; border: 1px solid black; font-weight: bold;">{{mStartDate |date:'dd/MM/yyyy'}} to {{mEndDate|date:'dd/MM/yyyy'}}</td>
        </tr>
        <tr>
          <th style="padding: 10px; border: 1px solid black;">Teachers session</th>
          <td style="padding: 10px; border: 1px solid black;">{{mTeacherSessions+mTeacherSessionsGroup-mDaysObserved}}</td>
        </tr>
        <tr>
          <th style="padding: 10px; border: 1px solid black;">Volunteers Session</th>
          <td style="padding: 10px; border: 1px solid black;">{{mVolunteerSessions+mVolunteerSessionsGroup}}</td>
        </tr>
        <tr>
          <th style="padding: 10px; border: 1px solid black;">Important days observed</th>
          <td style="padding: 10px; border: 1px solid black;">{{mDaysObserved}}</td>
        </tr>
        <tr>
          <th style="padding: 10px; border: 1px solid black;">Total Sessions</th>
          <td style="padding: 10px; border: 1px solid black;">{{mTeacherSessionsGroup+mTeacherSessions+mVolunteerSessionsGroup+mVolunteerSessions}}</td>
        </tr>
      </table>

      <div class="mx-8">
        <div>
          <div _ngcontent-xyl-c497="" class="font-bold" style="margin-top: 10px; font-weight: bold">Highlights:</div>
          <div style="min-height: 40px; text-justify: inter-word; text-align: justify" [innerHTML]="highlights"></div>
        </div>
      </div>
      <!-- CHART-->
      <!-- <div id='' style="page-break-after: always;" ></div> -->
      <div class="mx-8" *ngIf="mShowChart">
        <div class="">
          <div>
            <p class="text-center fw-bold " style="color:red; margin-top: 20px; text-align: center;">Note: The graphical
              representation is the Average Score
              of the percentage our children scored in Assessments.
              <br>
              <span *ngIf="mStartDate!=null && mEndDate!=null"> {{mCentre?.centreName}}
                , {{mStartDate|date:'dd MMMM yyyy'}} – {{mEndDate|date:'dd MMMM yyyy'}}</span>
            </p>

            <div class="header">
              <h4>PROGRESS CHART</h4>
            </div>

            <div class="text-center">
              <div class="chart-container col-md-10 text-center"> <!-- Apply the chart-container class here -->
                <apx-chart [series]="areaChartOptions.series!" [chart]="areaChartOptions.chart!"
                           [xaxis]="areaChartOptions.xaxis!" [yaxis]="areaChartOptions.yaxis!"
                           [colors]="areaChartOptions.colors!" [stroke]="areaChartOptions.stroke!"
                           [legend]="areaChartOptions.legend!" [grid]="areaChartOptions.grid!"
                           [tooltip]="areaChartOptions.tooltip!" [dataLabels]="areaChartOptions.dataLabels!"></apx-chart>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ══════════════ EDUCATION SESSION ══════════════ -->
      <div class="col-md-12 marginleft preview-section"
           *ngIf="selectedImagesEdu.length || galleryImagesEdu.length">
        <div class="preview-section-header">
          <span class="preview-section-dot" style="background:#673ab7;"></span>
          <h3 class="preview-section-title">Education Session</h3>
          <div class="preview-section-line"></div>
        </div>
        <div class="preview-image-grid">
          <ng-container *ngFor="let image of selectedImagesEdu; let i = index">
            <div class="preview-img-wrap">
              <img [src]="image" (click)="openImagePreview(image)" alt="Education" class="preview-img"/>
            </div>
          </ng-container>
          <ng-container *ngFor="let img of galleryImagesEdu; let i = index">
            <div class="preview-img-wrap">
              <img [src]="img.url" [alt]="img.fileName" (click)="openImageInNewTab(img.url)" class="preview-img"/>
              <div class="preview-img-caption" *ngIf="img.centreName">
                <small>{{ img.centreName }}</small>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- ══════════════ CELEBRATION ══════════════ -->
      <div class="col-md-12 marginleft preview-section"
           *ngIf="selectedImagesCelebration.length || galleryImagesCelebration.length">
        <div class="preview-section-header">
          <span class="preview-section-dot" style="background:#e91e63;"></span>
          <h3 class="preview-section-title">Special Day</h3>
          <div class="preview-section-line"></div>
        </div>
        <div class="preview-image-grid">
          <ng-container *ngFor="let image of selectedImagesCelebration; let i = index">
            <div class="preview-img-wrap">
              <img [src]="image" (click)="openImagePreview(image)" alt="Celebration" class="preview-img"/>
            </div>
          </ng-container>
          <ng-container *ngFor="let img of galleryImagesCelebration; let i = index">
            <div class="preview-img-wrap">
              <img [src]="img.url" [alt]="img.fileName" (click)="openImageInNewTab(img.url)" class="preview-img"/>
              <div class="preview-img-caption" *ngIf="img.centreName">
                <small>{{ img.centreName }}</small>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- ══════════════ VOLUNTEERING SESSION ══════════════ -->
      <div class="col-md-12 marginleft preview-section"
           *ngIf="selectedImagesVolunteering.length || galleryImagesVolunteering.length">
        <div class="preview-section-header">
          <span class="preview-section-dot" style="background:#388e3c;"></span>
          <h3 class="preview-section-title">Volunteering Session</h3>
          <div class="preview-section-line"></div>
        </div>
        <div class="preview-image-grid">
          <ng-container *ngFor="let image of selectedImagesVolunteering; let i = index">
            <div class="preview-img-wrap">
              <img [src]="image" (click)="openImagePreview(image)" alt="Volunteering" class="preview-img"/>
            </div>
          </ng-container>
          <ng-container *ngFor="let img of galleryImagesVolunteering; let i = index">
            <div class="preview-img-wrap">
              <img [src]="img.url" [alt]="img.fileName" (click)="openImageInNewTab(img.url)" class="preview-img"/>
              <div class="preview-img-caption" *ngIf="img.centreName">
                <small>{{ img.centreName }}</small>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Image Preview Popup -->
      <div *ngIf="showPreview"
           style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.7); z-index: 9999; display: flex; align-items: center; justify-content: center;">
        <div style="position: relative;">
          <img [src]="previewImageUrl" alt="Preview" style="max-width: 90vw; max-height: 90vh; border: 4px solid #fff; border-radius: 8px;" />
          <button (click)="closeImagePreview()"
                  style="position: absolute; top: 8px; right: 8px; background: #fff; border: none; border-radius: 50%; width: 32px; height: 32px; font-size: 20px; cursor: pointer;">&times;</button>
        </div>
      </div>
    </section>

  </div>

</main>
